import { Component, Input, OnInit } from '@angular/core';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { LabelListModel } from './label-list-model';

@Component({
	selector: 'nx-ahs-label-list',
	templateUrl: './label-list.component.html',
	styleUrls: ['./label-list.component.scss'],
	standalone: false
})
export class LabelListComponent extends AHSTripettoComponent implements OnInit {
	@Input()
	models?: LabelListModel[];

	constructor() {
		super();
	}

	ngOnInit(): void {
		const data = this.scriptJsonStr;

		if (data) {
			this.models = JSON.parse(data) as any;
		}
	}
}
